import React from "react";
import { Link } from "react-router-dom";
import { categoryPath } from "@/lib/paths";

// Grouped subcategory navigation (e.g. "Linen & Textiles" / "Soft Furnishings" groups under one parent).
// `children` come from the API with an optional `group`; `activeId` highlights the current subcategory.
export default function SubcategoryNav({ parent, children, activeId, compact = false }) {
  const kids = (children || []).filter((c) => !c.is_coming_soon);
  if (kids.length === 0) return null;
  const groups = kids.reduce((acc, c) => { const g = c.group || "Subcategories"; (acc[g] = acc[g] || []).push(c); return acc; }, {});
  return (
    <div className={`${compact ? "mb-4" : "mb-6"} bg-white border border-[#E8ECE9] p-4 sm:p-5`} data-testid="subcategory-nav">
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-3">
        <div className="tracking-overline text-[10px] text-[#264839]">Browse {parent?.name || "this category"} by subcategory</div>
        {activeId && parent && (
          <Link to={categoryPath(parent)} className="text-xs text-[#7D8C85] hover:text-[#264839] underline underline-offset-2" data-testid="subcategory-nav-all">All {parent.name} suppliers</Link>
        )}
      </div>
      <div className={`grid gap-4 ${Object.keys(groups).length > 1 ? "md:grid-cols-2" : ""}`}>
        {Object.entries(groups).map(([group, items]) => (
          <div key={group} data-testid={`subcategory-group-${group.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}>
            <div className="font-serif text-lg text-[#11211A] mb-2">{group}</div>
            <div className="flex flex-wrap gap-2">
              {items.map((c) => {
                const active = c.id === activeId;
                return (
                  <Link
                    key={c.id}
                    to={categoryPath(c)}
                    className={`text-xs px-3 py-1.5 border transition-colors ${active ? "bg-[#264839] text-white border-[#264839]" : "border-[#C4CFC9] text-[#4A5550] hover:border-[#264839] hover:text-[#264839]"}`}
                    data-testid={`subcategory-chip-${c.slug}`}
                  >
                    {c.name}
                  </Link>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
